import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UmsService } from '../ums.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute,Router } from '@angular/router';


@Component({
  selector: 'app-deb-user-details',
  templateUrl: './deb-user-details.component.html',
  styleUrls: ['./deb-user-details.component.scss']
})
export class DebUserDetailsComponent implements OnInit {

  submitpayload: any;
  debUserForm: FormGroup;
  debID: any;
  payload: any;
  DebId: any;
  DebMob: any;
  DebUsername: any;
  DebEmail: any;
  randomPassword: any;

  constructor(
     public umsService: UmsService,
     private fb: FormBuilder,
     private spinner: NgxSpinnerService,
     private route: ActivatedRoute,
     public router: Router,
  ) { }

  ngOnInit(): void {

    this.route.queryParams.subscribe((params) => {
      this.debID = params['debID'];
    });

    this.debUserForm = this.fb.group({
      debName: new FormControl('', [Validators.required,]),
      debGender: new FormControl('', [Validators.required,]),
      debDOB: new FormControl('', [Validators.required]),
      debEmail: new FormControl('', [Validators.required,]),
      debMobile: new FormControl('', [Validators.required,]),
      ABCID: new FormControl('', [Validators.required]),
      DEBID: new FormControl('', [Validators.required]),
      
        });

    this.getDEBDetails();
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  getDEBDetails() {
   // this.submitpayload={};
      this.submitpayload = {
      "debID"  :this.debID
      }
        this.umsService.getDEBDetails(this.submitpayload).subscribe((res) => {
          this.prepopulation(res);
          
      
        }, (ERROR: HttpErrorResponse) => {
        //  alert(ERROR.error.message);
            }
      )
  }

  prepopulation(res) {
    this.DebId = res.data.Resource[0].DEBUniqueID
    this.DebMob = res.data.Resource[0].mobile
    this.DebUsername = res.data.Resource[0].stdname
    this.DebEmail = res.data.Resource[0].email
    this.debUserForm = this.fb.group({
      debName: new FormControl(res.data.Resource[0].stdname, [Validators.required,]),
      debGender: new FormControl(res.data.Resource[0].Gender, [Validators.required,]),
      debDOB: new FormControl(res.data.Resource[0].DOB, [Validators.required,]),
      debEmail: new FormControl(res.data.Resource[0].email, [Validators.required,]),
      debMobile: new FormControl(res.data.Resource[0].mobile, [Validators.required,]),
      ABCID: new FormControl(res.data.Resource[0].ABCID, [Validators.required,]),
      DEBID: new FormControl(res.data.Resource[0].DEBUniqueID, [Validators.required,]),
    });
  }

  generateRandomPassword(): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const length = 5;
    this.randomPassword = '';
    
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      this.randomPassword += characters[randomIndex];
    }
    
    return this.randomPassword;
  }

  convertDateFormat(inputDate: string): string {
    // Split the input string assuming it's in dd/mm/yyyy format
    const [day, month, year] = inputDate.split('/');
    
    return `${year}-${month}-${day}`;
  }

  registerDEBUser() {
    this.generateRandomPassword();
    this.spinner.show();
    this.payload={};
    this.payload['StuabcID'] = this.debUserForm.controls['ABCID'].value;
    this.payload['StudebID'] = this.debUserForm.controls['DEBID'].value;
    this.payload['StuCountryCode'] = '';
    this.payload['StuEmailId'] = this.debUserForm.controls['debEmail'].value;
    this.payload['StuFirstName'] = '';
    this.payload['StuLastName'] =  '';
    this.payload['StuMidName'] = '';
    this.payload['StuFullName'] = this.debUserForm.controls['debName'].value;
    this.payload['StuMobNumber'] = this.debUserForm.controls['debMobile'].value;
    this.payload['StuPassword'] = this.randomPassword;
    this.payload['StuPassword1'] = this.randomPassword;
    this.payload['StuRegStatus'] = 1;
    this.payload['Dob'] = this.convertDateFormat(this.debUserForm.controls['debDOB'].value);
    this.payload['Gender'] = this.debUserForm.controls['debGender'].value;
    this.umsService.studRegistrationDetails(this.payload).subscribe(res => {
      // this.spinner.hide();
      if (res.status == true) {
        this.spinner.hide();
        console.log(res)
        alert('Registered Successfully!'+ "\n" + "User Id and Password have been sent to " + this.payload['StuEmailId'] +" and " + this.payload['StuMobNumber']);
      this.redirect('student-login');
      this.umsService.openSnackbar(res.message);
    }else{
      this.spinner.hide();
    }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      // alert(ERROR.error.message)
   });
  }

}
